import { QueryKey } from '@shared/config';
import { useQuery } from '@tanstack/react-query';
import { educationLevelApi } from '../educationLevelApi';

export const useGetEducationLevels = () => {
  return useQuery({
    queryKey: [QueryKey.GET_EDUCATION_LEVELS],
    queryFn: educationLevelApi.getEducationLevels,
  });
};
